import { copyTextToClipboard } from "@/lib/utils/copyToClipboard";

export const buildStudyGroupStreamPath = (studyGroupId: number): string => {
  return `/study-group/${studyGroupId}/stream`;
};

export const buildAllStudyGroupPath = (studyGroupId: number): string => {
  return `/all-study-groups/${studyGroupId}`;
};

export const buildPublicStudyGroupPath = (studyGroupGuid: string): string => {
  return `/public-study-group/${studyGroupGuid}`;
};

export const buildStudyGroupFilesPath = (
  studyGroupId: number,
  folderId?: number | null,
): string => {
  if (!folderId) {
    return `/study-group/${studyGroupId}/files`;
  }

  return `/study-group/${studyGroupId}/files/folder/${folderId}`;
};

export const buildStudyGroupPostPath = (
  studyGroupId: number,
  postId: number,
): string => {
  return `/study-group/${studyGroupId}/post/${postId}`;
};

export const buildStudyGroupLinkListPath = (
  studyGroupId: number,
  categoryId?: number | null,
): string => {
  if (!categoryId) {
    return `/study-group/${studyGroupId}/link-list`;
  }

  return `/study-group/${studyGroupId}/link-list/category/${categoryId}`;
};

export const toAbsoluteStudyGroupLink = (path: string): string => {
  return `${window.location.origin}${path}`;
};

export const generateStudyGroupStreamLink = (studyGroupId: number): string => {
  return toAbsoluteStudyGroupLink(buildStudyGroupStreamPath(studyGroupId));
};

export const generateAllStudyGroupLink = (studyGroupId: number): string => {
  return toAbsoluteStudyGroupLink(buildAllStudyGroupPath(studyGroupId));
};

export const generatePublicStudyGroupLink = (
  studyGroupGuid: string,
): string => {
  return toAbsoluteStudyGroupLink(buildPublicStudyGroupPath(studyGroupGuid));
};

export const copyStudyGroupLinkToClipboard = async (
  studyGroupId: number,
): Promise<void> => {
  await copyTextToClipboard(generateAllStudyGroupLink(studyGroupId));
};

export const copyPublicStudyGroupLinkToClipboard = async (
  studyGroupGuid: string,
): Promise<void> => {
  await copyTextToClipboard(generatePublicStudyGroupLink(studyGroupGuid));
};
